/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type GenerateAssistantResponseRequest = {
    message: string;
    /**
     * Optional model alias forwarded to better-agents. Defaults to Opus when omitted.
     */
    model?: GenerateAssistantResponseRequest.model;
    /**
     * Client-minted turn id. Forwarded downstream so a later cancel request can stop this turn's in-flight work cooperatively.
     */
    cancellationId?: string;
};

export namespace GenerateAssistantResponseRequest {

    /**
     * Optional model alias forwarded to better-agents. Defaults to Opus when omitted.
     */
    export enum model {
        OPUS = 'opus',
        SONNET = 'sonnet',
        HAIKU = 'haiku',
    }


}

